import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { searchOrgsRoutePathByLocale } from '#/modules/search/routing/search.route-paths';
import type { searchOrgsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { SearchOrgsPageLoadable } from './SearchOrgsPageLoadable';

export const handle = {
  urlByLocale: searchOrgsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'ORG',
  hideFooterDivider: true,
  showDesktopSearch: true,
  searchFromPageType: 'SEARCH',
  showSearchRefinements: true,
  isSearchPage: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchOrgsRouteReference>,
) {
  await SearchOrgsPageLoadable.load();
}

export default function SearchOrgsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <SearchOrgsPageLoadable />;
}
